import type { Variants as TagVariants } from '@ds/components/Tag/Tag.constant'

import { STATUS_COLORS } from './Invoices.constants'
import type { StatusColorKey } from './Invoices.types'

export function getStatusVariant(status: StatusColorKey | string) {
  return (STATUS_COLORS[status as StatusColorKey] || 'secondary') as TagVariants
}
